module.exports = __webpack_public_path__ + "static/media/ca_poster1.ad287231.jpg";